var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"400px","height":"400px"},attrs:{"id":"elec-energy-pie-day"}})
}
var staticRenderFns = []

export { render, staticRenderFns }